import type { PreIntentInstallModalProps } from './PreIntentInstallModal';
import type { WidgetAppsIntentInstallModalProps } from './WidgetAppsIntentInstallModal';

export const enum IntentInstallPanelsNames {
  PreIntentInstallModal = 'PreIntentInstallModal',
  WidgetAppsIntentInstallModal = 'WidgetAppsIntentInstallModal',
}

export type IntentModalsProps = {
  [IntentInstallPanelsNames.PreIntentInstallModal]: PreIntentInstallModalProps;
  [IntentInstallPanelsNames.WidgetAppsIntentInstallModal]: WidgetAppsIntentInstallModalProps;
};

export type { WidgetsConfiguration } from './WidgetAppsIntentInstallModal';
